export default {
  contracts: [],
  contractsTotalCount: 0,
  unprocessedContracts: [],
  unprocessedContractsTotalCount: 0,
  selectedContract: {},
  contractInstallments: [],
  selectedContractInstallment: {},
  contractLands: [], // Usado para exibir no mapa
  contractInstallmentGroups: [],
  selectedContractInstallmentGroup: {},
  landContracts: [], // Todos os contratos de um terreno
  contractCustomers: []
}
